export default __webpack_public_path__ + "static/media/br-rozetka.08ea1aac.svg";